import { useState, useEffect } from 'react';
import { is_touch_device } from './index';

var toXPorciento = function toXPorciento(val, rect) {
  return 100 * val / rect.width;
};

var toYPorciento = function toYPorciento(val, rect) {
  return 100 * val / rect.height;
};

var isTouchDevice = is_touch_device();
var moveEvent = isTouchDevice ? 'touchmove' : 'mousemove';
var downEvent = isTouchDevice ? 'touchstart' : 'mousedown';
var upEvent = isTouchDevice ? 'touchend' : 'mouseup';

var useEscalable = function useEscalable(_ref) {
  var elementRef = _ref.elementRef,
      tiradorRef = _ref.tiradorRef,
      onStart = _ref.onStart,
      onEscalando = _ref.onEscalando,
      onStop = _ref.onStop;

  var _useState = useState(false),
      escalando = _useState[0],
      setEscalando = _useState[1];

  var _useState2 = useState(null),
      ancla = _useState2[0],
      setAncla = _useState2[1]; //
  // start
  //


  useEffect(function () {
    if (!tiradorRef.current) {
      return;
    }

    if (escalando) {
      return;
    }

    function handleDown(e) {
      e.stopPropagation();
      var parentRect = elementRef.current.parentNode.getBoundingClientRect();
      var rect = elementRef.current.getBoundingClientRect();
      var tam = {
        w: toXPorciento(rect.width, parentRect),
        h: toYPorciento(rect.height, parentRect)
      };

      var _ref2 = e.touches ? e.touches[0] : e,
          clientX = _ref2.clientX,
          clientY = _ref2.clientY; // setSize(size)


      setAncla({
        clientX: clientX,
        clientY: clientY,
        size: tam
      });
      setEscalando(true);
      onStart && onStart(tam);
    }

    var tirador = tiradorRef.current;
    tirador.addEventListener(downEvent, handleDown);
    return function () {
      tirador.removeEventListener(downEvent, handleDown);
    };
  }, [escalando, elementRef, tiradorRef, onStart]); //
  // escalando
  //

  useEffect(function () {
    if (!escalando) {
      return;
    }

    function handleMove(e) {
      e.preventDefault();
      var parentRect = elementRef.current.parentNode.getBoundingClientRect();

      var _ref3 = e.changedTouches ? e.changedTouches[0] : e,
          clientX = _ref3.clientX,
          clientY = _ref3.clientY;

      var tam = {
        w: ancla.size.w + toXPorciento(clientX - ancla.clientX, parentRect),
        h: ancla.size.h + toYPorciento(clientY - ancla.clientY, parentRect)
      };
      onEscalando && onEscalando(tam);
    }

    window.addEventListener(moveEvent, handleMove);
    return function () {
      window.removeEventListener(moveEvent, handleMove);
    };
  }, [escalando, ancla, elementRef, onEscalando]); //
  // stop
  //

  useEffect(function () {
    if (!escalando) {
      return;
    }

    function handleUp(e) {
      setEscalando(false);
      onStop && onStop();
    }

    window.addEventListener(upEvent, handleUp);
    return function () {
      window.removeEventListener(upEvent, handleUp);
    };
  }, [escalando, onStop]);
  return {
    escalando: escalando
  };
};

export default useEscalable;